module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0043.jpg?v=3b29a887";